export default __webpack_public_path__ + "static/media/background-grass3.c1458a7e.png";